import React from 'react';
import moment from "moment";
import store from "../../store";
import { installments, installmentsAverage, installmentsPerPeriod } from "../../providers/charts";
import StockChart from "./stockChart/StockChart";
import Gauge from "./gaugeChart/Gauge";
import { formatAmount, setChartDates } from "../../lib/utils";
import ChartDropdown from "./ChartDropdown";
import NoChartData from "../common/NoChartData";
import Loader from "../common/Loader";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";

const I18n = require('react-redux-i18n').I18n;
const Translate = require('react-redux-i18n').Translate;

const stateMap = (store) => ({
    i18n: store.i18n,
    chartReducer: store.chartReducer
});

class TransactionsWithInstallmentsChart extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            afm: props.afm,
            mid: props.mid,
            installmentsData: null,
            installmentsMode: false,
            dateFrom: moment(moment().subtract(1, 'days')).subtract(1, 'week').format('YYYY-MM-DD'),
            dateTo: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            installmentsDropdownTooltip: I18n.t('tooltips.hover.timeDropdown04'),
            minAmount: null,
            maxAmount: null,
            averageAmount: null,
            periodType: null,
            periodDiff: null,
            perPeriod: null
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchInstallmentsTotals();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.afm !== prevProps.afm ||
            this.props.mid !== prevProps.mid ||
            this.props.i18n.locale !== prevProps.i18n.locale
        ) {
            this.setState(
                { afm: this.props.afm, mid: this.props.mid },
                () => this.fetchInstallmentsTotals()
            );
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchInstallmentsTotals = () => {
        const { afm, mid, dateFrom, dateTo } = this.state;
        const data = { afm, mid, dateFrom, dateTo };

        store.dispatch(installments(data)).then((response) => {
            if (this._isMounted) {
                this.setState({ installmentsData: response.value.data });
            }
        });

        store.dispatch(installmentsAverage(data)).then((response) => {
            if (this._isMounted && response.value.data.payload.length > 0) {
                const { minAmount, maxAmount, averageAmount } = response.value.data.payload[0];
                this.setState({ minAmount, maxAmount, averageAmount });
            }
        });

        store.dispatch(installmentsPerPeriod(data)).then((response) => {
            if (this._isMounted) {
                const { periodType, periodDiff, perPeriod } = response.value.data;
                this.setState({ periodType, periodDiff, perPeriod });
            }
        });
    }

    installmentsModeCheck = () => {
        this.setState(prevState => ({ installmentsMode: !prevState.installmentsMode }));
    }

    setNewDates = (dateFrom, dateTo) => {
        this.setState({ dateFrom, dateTo }, this.fetchInstallmentsTotals);
    }

    render() {
        const { afm, mid, dateFrom, dateTo, installmentsData, installmentsMode, minAmount, maxAmount, averageAmount, periodType, perPeriod } = this.state;
        const currency = "€";
        const perPeriodFormatted = perPeriod ? formatAmount(I18n._locale, perPeriod, 0) : 0;

        const { chartReducer } = this.props;
        const installmentsFetched = chartReducer?.installments?.fetched;
        const installmentsAverageFetched = chartReducer?.installmentsAverage?.fetched;
        const installmentsPerPeriodFetched = chartReducer?.installmentsPerPeriod?.fetched;
        const installmentsFetching = chartReducer?.installments?.fetching;
        const installmentsAverageFetching = chartReducer?.installmentsAverage?.fetching;
        const installmentsPerPeriodFetching = chartReducer?.installmentsPerPeriod?.fetching;

        return (
            <div className="reports__installments--chart">
                <div className="date-align-right__wrapper">
                    {this.props.renderDates(dateFrom, dateTo)}
                </div>

                <div className="dates__chart-dropdown__wrapper" title={this.state.installmentsDropdownTooltip}>
                    <ChartDropdown
                        id="installments-total-chart-timespan"
                        chartMaps={this.props.chartMaps}
                        data={{ afm, mid }}
                        reRenderChart={this.fetchInstallmentsTotals}
                        setDates={setChartDates}
                        setDatesInParent={this.setNewDates}
                        dropdownBaseValue="pages.reports.chart.dropdown.baseValueWeek"
                    />
                </div>

                {installmentsFetched && installmentsAverageFetched && installmentsPerPeriodFetched ? (
                    installmentsData && installmentsData.length > 0 ? (
                        <div className="installments__outter__wrapper">
                            <div className="reports__transactions--chart installments--chart col-md-10 col-sm-12 col-xs-12">
                                <StockChart
                                    key="installments-stock-chart"
                                    data={installmentsData}
                                    column={installmentsMode ? 'count' : 'amount'}
                                    panelType={installmentsMode ? 'line' : 'step'}
                                    id={'TransactionsWithInstallments'}
                                    filename={I18n.t("pages.reports.titles.installmentsTotals")}
                                    dates={{ dateFrom, dateTo }}
                                />

                                <div className="reports__chart-switch chart-left reports__chart-switch--blue-orange-reversed">
                                    <div className={`orange__switch report-translate${!installmentsMode ? "_active" : ""}`}>
                                        <Translate value="pages.reports.amountTitle"/>
                                    </div>
                                    <input
                                        type="checkbox"
                                        className="cbx"
                                        id='installmentsMode'
                                        checked={installmentsMode}
                                        onChange={this.installmentsModeCheck}
                                    />
                                    <label htmlFor="installmentsMode" className="toggle"><span/></label>
                                    <div className={`blue__switch report-translate${installmentsMode ? "_active" : ""}`}>
                                        <Translate value="pages.reports.countTitle"/>
                                    </div>
                                </div>
                            </div>

                            <div className="reports__transactions--chart installments__gauge col-md-2 col-sm-12 col-xs-12">
                                {periodType && (
                                    <div className="per-period__wrapper">
                                        <h6>
                                            <span className="per-period__value">{perPeriodFormatted}</span>
                                            <Translate className="per-period__type" value={`pages.reports.installments.${periodType}`}/>
                                        </h6>
                                        <Translate className="per-period__caption" value="pages.reports.installments.perPeriodCaption"/>
                                    </div>
                                )}
                                <Gauge currency={currency} min={minAmount} max={maxAmount} average={averageAmount} label={"installmentsLabel"}/>
                            </div>
                        </div>
                    ) : (
                        <NoChartData/>
                    )
                ) : null}

                {(installmentsFetching || installmentsAverageFetching || installmentsPerPeriodFetching) && (
                    <Loader bouncing={false} color={'bahama-blue'} message=''/>
                )}
            </div>
        );
    }
}

export default withRouter(connect(stateMap)(TransactionsWithInstallmentsChart));
